<template>
  <div id="tabBarItem" @click="itemClick" >
    <!-- <div v-show="(type === 'mine' && $store.state.commonParameters.serviceOn === 'true')?$store.state.unreadMessages !== 0:false" id="redPoint"></div> -->
    <div v-if="selectActive"><slot  name="selectedImg"></slot></div>
    <div v-else><slot  name="unselectedImg"></slot></div>
  </div>
</template>

<script>
 export default {
  name:"TabBarItem",
  props:{
    path:{type:String},
    type:{type:String},
    showRedPoint:{type:Boolean}
  },
   data () {
     return {

     }
   },
   components: {

   },
   methods:{
    itemClick:function(){
      // console.log(this.type);
      if("close" === this.type){
        this.$emit("close")
        return
      }
      if(this.path == this.$route.path){
        return
      }
      // console.log("replace", this.path);
      // console.log(this.$router)
      this.$router.replace(this.path) 
    }
   },
   computed:{
    selectActive(){
      return this.path == this.$route.path || 
      (this.path === "/toutiaomine" && ("/cashout" === this.$route.path || "/changePassword" === this.$route.path)) ||
      (this.path === "/toutiaorebate" && ("/toutiaorule" === this.$route.path))
    }
   },
  //  beforeRouteLeave(to,from,next){

  //   next()
  //  }
 }
</script>

<style>

#tabBarItem{
  /* text-align: center; */
  height: 100px;
  align-items: Center; /*垂直居中*/
  justify-content: center;
  display: flex;
  flex-direction: row;
}
#tabBarItem img{
  /* height: 40px;
  width: 30px; */
  vertical-align: middle;
  /* 解决图片拉伸问题 */
  object-fit: scale-down;
}
#redPoint{
  width: 15px;
  height: 15px;
  position: absolute;
  float: right;
  margin-left: 5px;
  /* margin-right: 10px; */
  /* margin-top: 10px; */
  background-color: red;
  border-radius: 10px 10px 10px 10px;
}

</style>


// WEBPACK FOOTER //
// src/views/TouTiaoApp/TabBarItem.vue